// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Fhv2","inputDescription":"styles_inputDescription__2-4Xa"};